package one.devsbox.www.provider

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.runtime.staticCompositionLocalOf
import one.devsbox.shared.ads.SharedIO

@Suppress("unused")
val LocalMeProvider =
    staticCompositionLocalOf<MeProvider> { error("LocalMeProvider is not implemented by CompositionLocalProvider") }


interface MeProvider {
    val info: SharedIO.User
    val permission: SharedIO.Permission.PermissionWrapper
}

class UserInfoProvider : MeProvider {
    var ready by mutableStateOf(false)
    private set

    override var info: SharedIO.User by mutableStateOf(SharedIO.User())
        private set
    override var permission: SharedIO.Permission.PermissionWrapper by mutableStateOf(info.permission.wrapper())
        private set

    fun configure(newInfo: SharedIO.User) {
        info = newInfo
        permission = newInfo.permission.wrapper()
        ready = true
    }
}